import {Injectable} from '@angular/core';
import {ActivatedRoute, CanLoad, Route, Router, UrlSegment} from '@angular/router';
import {OrderManager} from 'aigens-ng-core';
import {Observable} from 'rxjs';
import {NavController} from '@ionic/angular';
import {NavigationService} from '../services/navigation.service';
import { OrderService } from '../services/order.service';

@Injectable({
    providedIn: 'root'
})
export class CrmFeatureGuard implements CanLoad {
    constructor(public orderManger: OrderManager,
        public orderService: OrderService, public router: Router, public route: ActivatedRoute, public navController: NavController, public navigationService: NavigationService) {
    }

    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        console.log('can crm load', this.orderManger);
        let courtBrand = this.orderService.courtBrand;
        if (
            (this.orderManger.store && this.orderManger.store.brand && this.orderManger.store.brand.hasFeature('login'))
            ||
            (this.orderService.isCourt && courtBrand && courtBrand.features && courtBrand.features.includes('login'))
        ) {
            return true;
        }else{
            const t = this.navigationService.getRootPageUrl();
            console.log('home guard', t);

            if (t) {
                // TODO: not allowed to enter target root. go to parent route?
                this.navController.setDirection('root');
                this.router.navigate([this.navigationService.getRootPageUrl()]);
            }
            return false;
        }
    }
}

